module.exports = __webpack_public_path__ + "static/media/icon1-red.e27afff4.png";